<div class="container-fluid">
  <div class="row">
      <mat-form-field appearance="outline" class="col-md-3">
        <mat-label>Enter week date range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate [(ngModel)]="startDate1" placeholder="Start date">
          <input matEndDate [(ngModel)]="endDate1" placeholder="End date" (dateChange)="onEndDateChanged()">
        </mat-date-range-input>
        <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
      <app-searchable-select class="col-md-3"
                             [multiple]="true"
                             [options]="centres$ | async"
                             [selectedValue]="selectedCentre"
                             [displayWithFn]="displayCentre"
                             [placeholder]="'Select Centre'"
                             [label]="'Select Centre'"
                             (selectionChange)="onCentreSelect($event)"
      ></app-searchable-select>
      <mat-form-field appearance="outline" class="col-md-2">
        <mat-label>Gender</mat-label>
        <mat-select [(ngModel)]="selectedGender">
          <mat-option value="All">All</mat-option>
          <mat-option value="Male">Male</mat-option>
          <mat-option value="Female">Female</mat-option>
        </mat-select>
      </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-2">
      <mat-label>Admission Type</mat-label>
      <mat-select [(ngModel)]="typeSelected">
        <mat-option value="All">All</mat-option>
        <mat-option value="Admission">Admission</mat-option>
        <mat-option value="Discharge">Discharge</mat-option>
        <mat-option value="FollowUpAdmission">Follow Up Admission</mat-option>
        <mat-option value="FollowUpDischarge">Follow Up Discharge</mat-option>
        <mat-option value="Transfer">Transfer</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-2">
      <mat-label>Blood Group</mat-label>
      <mat-select [(ngModel)]="selectedBloodGroup">
        <mat-option value="All">All</mat-option>
        <mat-option *ngFor="let bg of bloodGroups" [value]="bg">
          {{ bg }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <app-searchable-select class="col-md-3"
                           [multiple]="true"
                           [options]="hospitalOptions"
                           [selectedValue]="selectedHospital"
                           [displayWithFn]="displayHospital"
                           [placeholder]="'Select Hospital'"
                           [label]="'Hospital'"
                           (selectionChange)="onHospitalSelect($event)">
    </app-searchable-select>
    <app-searchable-select
      class="col-md-3"
      [multiple]="true"
      [options]="_diagnosis$ | async"
      [selectedValue]="selectedDiagnosis"
      [displayWithFn]="displayDiagnosis"
      [placeholder]="'Select Diagnosis'"
      [label]="'Diagnosis'"
      (selectionChange)="onDiagnosisSelect($event)">
    </app-searchable-select>

    <app-searchable-select
      class="col-md-3"
      [multiple]="false"
      [options]="states"
      [selectedValue]="selectedLocation"
      [displayWithFn]="displayState"
      [placeholder]="'Select State'"
      [label]="'State'"
      (selectionChange)="onStateSelect($event)">
    </app-searchable-select>

    <div class="col-md-2">
      <button mat-mini-fab (click)="dynamicQuery()" color="accent" permission="Admission Log History" [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-mini-fab (click)="clearAll()" color="accent" style="margin-left: 10px;">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>
  <div class="row mb-2">

    <div class="note col-md-12">
      Use this to generate custom reports or re-arrange columns
    </div>

    <mat-form-field class="col-md-12" appearance="outline">
      <mat-label>Columns</mat-label>

      <mat-select
        [value]="displayedColumns"
        multiple
        (selectionChange)="onColumnsSelected($event)"
        (opened)="resetColumnFilter()">

        <!-- SEARCH -->
        <div class="mat-select-search">
          <input
            matInput
            placeholder="Search columns..."
            [formControl]="columnSearchControl"
            autocomplete="off"
            (keydown)="$event.stopPropagation()"
            (click)="$event.stopPropagation()"
            (mousedown)="$event.stopPropagation()"
            (focus)="$event.stopPropagation()">
        </div>

        <!-- OPTIONS -->
        <mat-option
          *ngFor="let col of filteredDynamicColumns"
          [value]="col.value">
          {{ col.label }}
        </mat-option>

      </mat-select>
    </mat-form-field>

  </div>


  <div class="d-flex flex-wrap">
    <mat-card class="col-md-12 col-sm-12 mb-4">
      <div class="ngxTableHeader">
        <ul class="header-buttons-left ms-0 mb-0">
          <li class="dropdown">
            <h2>Admission Log History <span *ngIf="startDate1">{{startDate1|date:'dd/MM/yyyy'}}</span><span *ngIf="endDate1">  -  {{endDate1|date:'dd/MM/yyyy'}}</span></h2>
          </li>
          <li class="dropdown m-l-20">
            <label for="search-input"><i class="material-icons search-icon">search</i></label>
            <input placeholder="Search" type="text" id="search-input" class="browser-default search-field"
                   (keyup)='applyFilter($event)' aria-label="Search box" #input>
          </li>
        </ul>
        <ul class="header-buttons mr-2">

          <li>
            <div  class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()" permission="Admission Log History" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]" >
              <img src="../../../../../assets/images/icons/xlsx.png" alt="" />
            </div>
          </li>
        </ul>
      </div>
      <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading... </mat-progress-bar>
      <div class="table-responsive-wrapper">
      <table mat-table [dataSource]="dataSource" matSort>

        <ng-container *ngFor="let col of displayedColumns" [matColumnDef]="col">

          <!-- HEADER -->
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ columnLabelMap[col] }}
          </th>

          <!-- CELL -->
          <td mat-cell *matCellDef="let row; let i = index">

            <ng-container [ngSwitch]="col">

              <!-- SR NO -->
              <span *ngSwitchCase="'srNo'">{{ i + 1 }}</span>

              <!-- DATE -->
              <span *ngSwitchCase="'dateOfAdmission'">
          {{ row.dateOfAdmission?.toDate() | date:'dd/MM/yyyy' }}
        </span>

              <!-- DIAGNOSIS ARRAY -->
              <span *ngSwitchCase="'diagnosis'">
          {{ row.diagnosis?.join(', ') }}
        </span>

              <!-- DEFAULT -->
              <span *ngSwitchDefault>
          {{ row[col] }}
        </span>

            </ng-container>

          </td>

        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>
        <mat-paginator
          [pageSizeOptions]="[10, 25, 50, 100]"
          [pageSize]="10"
          showFirstLastButtons>
        </mat-paginator>

      </div>

    </mat-card>

  </div>


</div>
